export default {
    replaceCardsOption: {
        dataTrackId: 'replace-cards-option',
        dataTrackLinkname: 'erstatt kort - alternativ',
    },
    replaceExistingCardSelectCardForm: {
        dataTrackId: 'replace-existing-card-select-card-form',
        dataTrackLinkname: 'erstatt kort - velg kort',
    },
    replaceExistingCardConfirmForm: {
        dataTrackId: 'replace-existing-card-confirm-form',
        dataTrackLinkname: 'erstatt kort - bekreftelsesskjema',
    },
    replaceExistingCardHardBlockFailure: {
        dataTrackId: 'replace-existing-card-hard-block-failure',
        dataTrackLinkname: 'erstatt kort - permanent sperring feil',
    },
    replaceExistingCardReorderFailure: {
        dataTrackId: 'replace-existing-card-reorder-failure',
        dataTrackLinkname: 'erstatt kort - rebestilling feil',
    },
    replaceExistingCardSuccessReceipt: {
        dataTrackId: 'replace-existing-card-success-receipt',
        dataTrackLinkname: 'erstatt kort - suksess kvittering',
    },
    seePriceListCard: {
        dataTrackId: 'see-price-list-card',
        dataTrackLinkname: 'se prisliste for kort',
    },
    replaceExistingCardFormUserBelow18: {
        dataTrackId: 'replace-existing-card-form-user-below-18',
        dataTrackLinkname: 'erstatt kort - bruker er under 18',
    },
    replaceExistingCardNext: {
        dataTrackId: 'replace-existing-card-next',
        dataTrackLinkname: 'neste',
    },
    replaceExistingCardSuccessOk: {
        dataTrackId: 'replace-existing-card-success-ok',
        dataTrackLinkname: 'erstatt kort - suksess ok',
    },
    replaceExistingCardCancel: {
        dataTrackId: 'replace-existing-card-cancel',
        dataTrackLinkname: 'avbryt erstatt kort',
    },
    replaceExistingCardConfirm: {
        dataTrackId: 'replace-existing-card-confirm',
        dataTrackLinkname: 'bekreft erstatt kort',
    },
    pinChangeDecisionCancel: {
        dataTrackId: 'pin-change-decision-cancel',
        dataTrackLinkname: 'avbryt valg endre pin',
    },
    pinChangeDecisionNext: {
        dataTrackId: 'pin-change-decision-next',
        dataTrackLinkname: 'neste',
    },
    newPinConfirm: {
        dataTrackId: 'replace-existing-card-new-pin-entry-form-button',
        dataTrackLinkname: 'bekreft ny pin',
    },
    newPinForm: {
        dataTrackId: 'replace-existing-card-new-pin-entry-form',
        dataTrackLinkname: 'skjema for sett ny pin',
    },
};
